(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/models/xpert.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/models/xpert.js'); 
'use strict';

svs.maltipset.models.Xpert = Backbone.Model.extend({
  url: function() {
    var url =
        '/wager/xpertwagers/MAL?systemSize=' +
        this.getSystemSize() +
        '&systemType=' +
        this.getSystemType() +
        '&drawNumber=' +
        this.get('drawNumber') +
        '&numRows=' +
        this.getNumRows();

    if (this.get('baseRow')) {
      url += '&baseRow=' + this.get('baseRow').join(',');
    }

    return svs.core.jupiter.url() + url;
  },
  parse: function(response) {
    if (
      response.wager &&
        response.wager.bets &&
        response.wager.bets.length > 0
    ) {
      return response.wager.bets[0];
    }
  },
  getSystemSize: function() {
    if (this.get('system') === svs.maltipset.constants.SYSTEM.NO_SYSTEM) {
      return svs.maltipset.constants.NUMBER_OF_MATCHES_TO_SELECT_NOSYSTEM;
    } else if (
      this.get('system') === svs.maltipset.constants.SYSTEM.R_SYSTEM
    ) {
      return svs.maltipset.collections.Board.prototype.getRSystemRows(
        this.get('xpertSize')
      );
    } else if (
      this.get('system') === svs.maltipset.constants.SYSTEM.M_SYSTEM
    ) {
      return svs.maltipset.collections.Board.prototype.calculateMSystem(
        this.get('xpertSize')
      );
    }
  },
  getSystemType: function() {
    switch (this.get('system')) {
      case svs.maltipset.constants.SYSTEM.NO_SYSTEM:
        return 'SROW';
      case svs.maltipset.constants.SYSTEM.M_SYSTEM:
        return 'MSYS';
      case svs.maltipset.constants.SYSTEM.R_SYSTEM:
        return 'RSYS';
      default:
    }
  },
  getNumRows: function() {
    if (this.get('system') === svs.maltipset.constants.SYSTEM.NO_SYSTEM) {
      return this.get('xpertSize');
    }
    return 1;
  }
});

 })(window);